// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Auth } from 'aws-amplify';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { isEmail } from '../../../lib/validation';
import MemberContext from '../../../contexts/MemberContext';
import CommonContext from '../../../contexts/CommonContext';
import TextBoxInput from '../../../components/TextBoxInput';
import PasswordInput from '../../../components/PasswordInput';
import { BIFROST_URL } from '../../../configuration';
import S from './styles';
import { useIntl } from 'react-intl';
import LoginPopSubmit from '../components/LoginPopSubmit'
import { checkLoginMethod } from '../../../apis/member';
interface LoginFormProps {
  setLoginNotAuth: React.Dispatch<React.SetStateAction<string | undefined>>;
  loginNotAuth: string | undefined;
  checkCognitoStatus(): boolean;
}

const LoginForm = (props: LoginFormProps): JSX.Element => {
  const history = useHistory();
  const time = useRef<Date>();
  const member = useContext(MemberContext);
  const common = useContext(CommonContext);
  const [loginNotAuthId, setLoginNotAuthId] = useState<string>()
  const [clickSubmit, setClickSubmit] = useState(false);

  const gotoBirfrost = async () => {
    window.location.href = BIFROST_URL;
  }

  const checkLogin = async (email: string) => {
    const result = await checkLoginMethod(email);
    return result
  }

  const cognitoLogin = async (email: string, password: string) => {
    await Auth.signIn(email, password)
      .then(async (data) => {
        console.log({ data });
        await member.update();
        await common.update();
        history.push('/home');
      })
      .catch((error) => {
        console.log({ error });
        if (error.code === 'NotAuthorizedException') {
          setLoginNotAuthId('J011');
        } else if (error.code === 'UserNotConfirmedException') {
          const now = new Date();
          if (!time.current || (now.getTime() - time.current.getTime()) > 30000) {
            time.current = now;
            Auth.resendSignUp(email)
            setLoginNotAuthId('J063');
          } else {
            props.setLoginNotAuth('*此帳號尚未驗證成功');
          }
        } else {
          props.setLoginNotAuth(error.message);
        }
      });
  }

  const intl = useIntl();
  if (member.isLogin && props.checkCognitoStatus()) {
    return (
      <Redirect to="/home"></Redirect>
    )
  } else {
    return (
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validate={(values) => {
          const errors: { email?: string, password?: string } = { };
          if (!values.email) {
            errors.email = 'J008';
          } else if (!isEmail(values.email.trim())) {
            errors.email = 'J009';
          }

          if (!values.password) {
            errors.password = 'J010';
          }
          props.setLoginNotAuth(undefined);
          return errors;
        }}
        onSubmit={ async ({ email, password }, { setSubmitting, resetForm }) => {
          email = email.trim().toLowerCase();
          member.removeCognito();
          if (email.endsWith('@ecloudvalley.com')) {
            // check user login method, true: need to use bifrost, false: use cognito login
            const loginMethod = await checkLogin(email);
            if (loginMethod.data) {
              setClickSubmit(true);
            } else {
              await cognitoLogin(email, password);
              member.setIsBifrostLogin(false);
            }
          } else {
            await cognitoLogin(email, password);
            member.setIsBifrostLogin(true);
          }
          resetForm({ values: { email: email, password: '' } });
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting
        }) => {
          const intl = useIntl();
          const emailError = errors.email ? '*' + intl.formatMessage({ id: errors.email }) : undefined;
          const passwordError = errors.password ? '*' + intl.formatMessage({ id: errors.password }) : undefined;
          useEffect(() => {
            if (loginNotAuthId) {
              props.setLoginNotAuth(`*${intl.formatMessage({ id: loginNotAuthId })}`);
            }
          }, [loginNotAuthId, intl.messages])
          return (
            <S.Container as={Form}>
              <S.TopWrapper>
                <TextBoxInput
                  textBoxName={intl.formatMessage({ id: 'J003' })}
                  placeholder={intl.formatMessage({ id: 'J003' })}
                  name="email"
                  value={values.email || ''}
                  error={emailError}
                  errorAuth={!!props.loginNotAuth}
                  touched={touched.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoComplete="new-password"
                />
                <S.PasswordWrapper>
                  <PasswordInput
                    name="password"
                    label={intl.formatMessage({ id: 'J004' })}
                    placeholder={intl.formatMessage({ id: 'J004' })}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password || ''}
                    error={passwordError}
                    errorAuth={!!props.loginNotAuth}
                    touched={touched.password}
                    autoComplete="new-password" />
                  <S.GotoForgetPassword to={'/forgotPassword'}>{intl.formatMessage({ id: 'J005' })}</S.GotoForgetPassword>
                </S.PasswordWrapper>
              </S.TopWrapper>
              <S.BottomWrapper>
                <S.GoToNewAccountPageWrapper>
                  {intl.formatMessage({ id: 'J006' })}<S.GoToNewAccountPage to={'/register'}>{intl.formatMessage({ id: 'J006-1' })}</S.GoToNewAccountPage>
                </S.GoToNewAccountPageWrapper>
                <S.Button
                  type="submit"
                  disabled={isSubmitting || Object.keys(errors).length > 0}
                >{intl.formatMessage({ id: 'J007' })}</S.Button>
              </S.BottomWrapper>
              { clickSubmit ? <LoginPopSubmit setClickSubmit={setClickSubmit} gotoBirfrost={gotoBirfrost} messageId={'J065'}></LoginPopSubmit> : null}
            </S.Container>
          )
        }}
      </Formik>
    );
  }
}

export { LoginForm as default };
